export default  class Ui {
    constructor(rootStore) {
        this.rootStore = rootStore
    }
}
  
  